module.exports = __webpack_public_path__ + "img/research-sponsored-projects.2b8e3821.png";